import Vuex from "vuex";
import Vue from "vue";
import axios from "axios";
import router from "../router";
Vue.use(Vuex);

// Import States
import sidebarState from "../store/sidebar/index.js";
// Import Mutations
import sidebarMutation from "../store/sidebar/mutations";

const state = {
  ...sidebarState,
  token: null,
  userData: [],
  baseUrl: "https://sakip.bogorkab.go.id/v3/"
  // baseUrl: "http://192.168.56.56:4003/"
  //baseUrl : 'http://103.225.97.107/v3/'
  //baseUrl : 'http://103.225.97.32/v3/'
  //baseUrl : 'http://127.0.0.1:8000/'
};

const mutations = {
  ...sidebarMutation,
  setLoginState(state, payload) {
    state.token = payload.token;
    state.user = payload.data;
  },
  removeUserAuth(state) {
    (state.user = {}), (state.token = null), (state.roles = []);
  }
};

const actions = {
  getData(context, data) {
    return new Promise((resolve, reject) => {
      let url = this.state.baseUrl + data.url;
      let config = {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      let rows = [];
      axios
        .get(url, config)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          // router.push('/auth/login')
          //   console.log(error)
        });
    });
  },
  postData(context, data) {
    return new Promise((resolve, reject) => {
      let url = this.state.baseUrl + data.url;
      let config = {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      let rows = [];
      axios
        .post(url, data.params, config)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          router.push("/auth/login");
          //  reject(error)
        });
    });
  },
  deleteData(context, data) {
    return new Promise((resolve, reject) => {
      let url = this.state.baseUrl + data.url;
      let config = {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem("token")
        }
      };
      let rows = [];

      axios
        .post(url, { _method: "delete" }, config)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          router.push("/auth/login");
          //  reject(error)
        });
    });
  }
};
const getters = {};

export default new Vuex.Store({
  state,
  mutations,
  actions,
  getters
});



// WEBPACK FOOTER //
// ./src/store/index.js